// function that formats numbers into a string with leading zeros to reach a certain amount of characters
export default (number: number | string, length = 6) => {
  return String(number)
    .padStart(length, "0")
    .slice(-1 * length);
};
